/* Clinks geo-market layer.
 *
 * Every country domain serves the same store, so the announcement bar and
 * prices localize to the MARKET being served, not the visitor: a US visitor
 * on clinks.com.au sees AUD prices and "fast delivery from Sydney". This
 * script detects the visitor's country (Cloudflare trace on our own worker
 * host — no extra services), and when they're on the wrong domain it:
 *   1. swaps the announcement message for a country-targeted line linking
 *      to their site, and
 *   2. shows a one-time modal pushing them across (deep-linked to the same
 *      path — same store, same handles). "Stay on this site" is remembered.
 *
 * AUTO_REDIRECT: leave false. A silent IP redirect bounces Googlebot's US
 * crawlers off the AU domain and breaks shared links; the modal forces the
 * choice without those costs. Flip only with eyes open.
 *
 * Keep HOSTS in sync with SITES in delivery-estimator.js.
 * Test hook: ?geo=US fakes the detected country (and is the only way this
 * runs on *.myshopify.com previews).
 */
(function () {
  'use strict';

  var AUTO_REDIRECT = false;

  // Translated strings (injected by snippets/clinks-i18n.liquid); the inline
  // English below is the fallback when the snippet is absent.
  var I18N = (window.clinksI18n && window.clinksI18n.geo) || {};
  function T(key, fallback) { return I18N[key] || fallback; }
  function TR(key, fallback, tokens) {
    var s = T(key, fallback);
    for (var k in tokens) s = s.split('[' + k + ']').join(tokens[k]);
    return s;
  }

  var HOSTS = {
    AU: 'www.clinks.com.au',
    US: 'www.clinks.com',
    GB: 'www.clinks.co.uk',
    NZ: 'www.clinks.nz',
    SG: 'www.clinks.sg',
    DE: 'www.clinks.de',
    AE: 'www.clinks.ae',
    ES: 'www.clinks.es',
    FR: 'www.clinks.fr',
    IT: 'www.clinks.it',
  };
  var ROW_HOST = 'clinks.co'; // international store for everyone else

  var SITE_NAMES = {
    'www.clinks.com.au': 'our Australian store (AUD)',
    'www.clinks.com': 'our US store (USD)',
    'www.clinks.co.uk': 'our UK store (GBP)',
    'www.clinks.nz': 'our New Zealand store (NZD)',
    'www.clinks.sg': 'our Singapore store (SGD)',
    'www.clinks.de': 'our German store (EUR)',
    'www.clinks.ae': 'our UAE store (AED)',
    'www.clinks.es': 'our Spanish store (EUR)',
    'www.clinks.fr': 'our French store (EUR)',
    'www.clinks.it': 'our Italian store (EUR)',
    'clinks.co': 'our International store',
  };
  if (I18N.siteNames) { for (var sk in I18N.siteNames) SITE_NAMES[sk] = I18N.siteNames[sk]; }

  var COUNTRY_NAMES = {
    AU: 'Australia', US: 'the United States', GB: 'the United Kingdom',
    NZ: 'New Zealand', SG: 'Singapore', DE: 'Germany', AE: 'the UAE',
    ES: 'Spain', FR: 'France', IT: 'Italy', CA: 'Canada', IE: 'Ireland',
    AT: 'Austria', CH: 'Switzerland', NL: 'the Netherlands',
  };
  if (I18N.countryNames) { for (var ck in I18N.countryNames) COUNTRY_NAMES[ck] = I18N.countryNames[ck]; }
  // Shopify's static flag SVGs (the same set the currency picker uses) —
  // emoji flags render as bare letters on Windows, images render everywhere
  function flagImg(cc, size) {
    if (!/^[A-Z]{2}$/.test(cc)) return '';
    return '<img src="https://cdn.shopify.com/static/images/flags/' + cc.toLowerCase() + '.svg"' +
      ' width="' + size + '" alt="" style="display:inline-block;vertical-align:-2px;border-radius:2px" onerror="this.remove()">';
  }

  var TRACE = 'https://clinks-rates.ben-887.workers.dev/cdn-cgi/trace';

  var here = location.host;
  var debugGeo = new URLSearchParams(location.search).get('geo');
  var debugLang = new URLSearchParams(location.search).get('langnudge');
  var onPreview = /\.myshopify\.com$/.test(here);

  // The language nudge runs on every host (it has its own preview hook);
  // the country features below still need a real domain.
  scheduleLanguageNudge();

  if (onPreview && !debugGeo) return; // previews only run via the test hook

  function siteFor(cc) {
    return HOSTS[cc] || ROW_HOST;
  }

  function targetPath(cc) {
    // same store everywhere — carry the visitor to the same page
    var params = new URLSearchParams(location.search);
    params.delete('geo');
    params.delete('preview_theme_id');
    params.delete('ck-choice');
    params.delete('shpxid');
    params.delete('country');
    // an explicit cross-domain jump from our own UI: ?country= declares buyer
    // intent so Shopify's server-side country redirection lets the request
    // through (and sets the localization cookie); ck-choice tells the
    // target's copy of this script to suppress its own modal
    params.set('ck-choice', '1');
    if (/^[A-Z]{2}$/.test(cc || '')) params.set('country', cc);
    var qs = params.toString();
    return location.pathname + (qs ? '?' + qs : '');
  }

  function stayKey(cc) {
    return 'clinks-geo-stay-' + cc;
  }

  function detect(cb) {
    if (debugGeo) return cb(debugGeo.toUpperCase());
    var cached = '';
    try { cached = sessionStorage.getItem('clinks-geo') || ''; } catch (e) {}
    if (cached) return cb(cached);
    var ctrl = 'AbortController' in window ? new AbortController() : null;
    if (ctrl) setTimeout(function () { ctrl.abort(); }, 4000);
    fetch(TRACE, { signal: ctrl && ctrl.signal })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var m = t.match(/^loc=([A-Z]{2})$/m);
        if (!m) return;
        try { sessionStorage.setItem('clinks-geo', m[1]); } catch (e) {}
        cb(m[1]);
      })
      .catch(function () {});
  }

  function swapAnnouncement(cc, url) {
    var carousel = document.querySelector('.announcement-bar announcement-bar-carousel');
    if (!carousel) return;
    var name = COUNTRY_NAMES[cc] || T('your_country', 'your country');
    var flag = flagImg(cc, 16);
    var label = siteFor(cc).replace(/^www\./, '');
    carousel.removeAttribute('autoplay');
    // the theme caps the carousel at 560px (sized for its short rotating
    // lines) and prose caps text at ~65ch — both wrap this message
    carousel.style.maxWidth = 'none';
    carousel.innerHTML =
      '<p class="prose heading is-selected" style="max-width:none">' + (flag ? flag + ' ' : '') +
      TR('announce_pre', 'Shopping from [country]?', { country: name }) +
      ' <a href="' + url + '">' + TR('announce_link', 'Visit [site]', { site: label }) + '</a> ' +
      T('announce_post', 'for local prices &amp; delivery') + '</p>';
    var bar = carousel.closest('.announcement-bar');
    if (bar) {
      bar.querySelectorAll('carousel-prev-button, carousel-next-button').forEach(function (b) {
        b.style.display = 'none';
      });
    }
  }

  function showModal(cc, url) {
    var name = COUNTRY_NAMES[cc] || T('your_country', 'your country');
    var flag = flagImg(cc, 44) || '🌏';
    var hereName = SITE_NAMES[here] || T('this_store', 'this store');
    var target = siteFor(cc);

    var wrap = document.createElement('div');
    wrap.className = 'geo-push';
    wrap.innerHTML =
      '<div class="geo-push__overlay" data-geo-stay-soft></div>' +
      '<div class="geo-push__card" role="dialog" aria-modal="true" aria-labelledby="geo-push-title">' +
      '<div class="geo-push__flag" aria-hidden="true">' + flag + '</div>' +
      '<h2 id="geo-push-title" class="geo-push__title">' + TR('modal_title', 'It looks like you’re in [country]', { country: name }) + '</h2>' +
      '<p class="geo-push__body">' + TR('modal_body', 'You’re browsing [here]. [target] has prices in your currency and local delivery times.', { here: hereName, target: '<strong>' + target + '</strong>' }) + '</p>' +
      '<a class="geo-push__go" href="' + url + '">' + TR('shop_on', 'Shop on [site]', { site: target }) + '</a>' +
      '<button type="button" class="geo-push__stay" data-geo-stay>' + T('stay', 'Stay on this site') + '</button>' +
      '</div>';

    var css = document.createElement('style');
    css.textContent =
      '.geo-push { position: fixed; inset: 0; z-index: 200; display: grid; place-items: center; padding: 20px; }' +
      '.geo-push__overlay { position: absolute; inset: 0; background: rgb(21 35 70 / .45); }' +
      '.geo-push__card { position: relative; background: #fff; max-width: 400px; width: 100%; padding: 30px 26px 24px; border-radius: 12px; text-align: center; box-shadow: 0 18px 50px rgb(0 0 0 / .25); }' +
      '.geo-push__flag { font-size: 34px; line-height: 1; margin-block-end: 10px; }' +
      '.geo-push__title { font-size: 1.125rem; color: #152346; margin: 0 0 8px; }' +
      '.geo-push__body { font-size: .8125rem; line-height: 1.6; color: #444; margin: 0 0 18px; }' +
      '.geo-push__go { display: block; background: #152346; color: #fff; padding: 13px 18px; border-radius: 8px; font-size: .8125rem; font-weight: 600; text-decoration: none; }' +
      '.geo-push__go:hover { background: #0e2a58; }' +
      '.geo-push__stay { margin-block-start: 12px; border: 0; background: none; font: inherit; font-size: .75rem; color: rgb(0 0 0 / .55); text-decoration: underline; text-underline-offset: 2px; cursor: pointer; }';
    wrap.appendChild(css);
    document.body.appendChild(wrap);

    function close(persist) {
      wrap.remove();
      try {
        if (persist) localStorage.setItem(stayKey(cc), '1');
        else sessionStorage.setItem(stayKey(cc), '1');
      } catch (e) {}
    }
    wrap.querySelector('[data-geo-stay]').addEventListener('click', function () { close(true); });
    wrap.querySelector('[data-geo-stay-soft]').addEventListener('click', function () { close(false); });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { close(false); document.removeEventListener('keydown', esc); }
    });
  }

  /* ---- Browser-language nudge -------------------------------------------
   * A de/es/fr/it-preferring visitor on a market that PUBLISHES their
   * language, viewing it in another one, gets a small dismissible banner
   * linking to the same page under the language's path prefix.
   *
   * Strings are hardcoded per TARGET language (not locale files) on
   * purpose: the page renders in the wrong language for this visitor, so
   * t-filter output would be too — a German speaker must see German here.
   * Published languages + roots arrive via clinksI18n.langs (per-market).
   * The visitor's preference list is respected in order: anyone who ranks
   * the page's current language above ours is never nudged.
   * Test hook: ?langnudge=de forces the target language (works on previews
   * and ignores a stored dismissal).
   */
  var NUDGE_STRINGS = {
    de: { text: 'Diese Seite gibt es auch auf Deutsch.', cta: 'Auf Deutsch ansehen', dismiss: 'Schließen' },
    es: { text: 'Esta página también está disponible en español.', cta: 'Ver en español', dismiss: 'Cerrar' },
    fr: { text: 'Cette page existe aussi en français.', cta: 'Voir en français', dismiss: 'Fermer' },
    it: { text: 'Questa pagina è disponibile anche in italiano.', cta: 'Vedi in italiano', dismiss: 'Chiudi' },
    ja: { text: 'このページは日本語でもご覧いただけます。', cta: '日本語で見る', dismiss: '閉じる' },
  };

  function languageNudge() {
    var langs = (window.clinksI18n && window.clinksI18n.langs) || [];
    var current = ((window.clinksI18n && window.clinksI18n.locale) || 'en').toLowerCase().split('-')[0];
    if (!langs.length && !debugLang) return;

    var want = '';
    if (debugLang) {
      want = debugLang.toLowerCase();
    } else {
      var prefs = navigator.languages || [navigator.language || ''];
      for (var i = 0; i < prefs.length; i++) {
        var code = String(prefs[i] || '').toLowerCase().split('-')[0];
        if (code === current) return; // current language outranks ours — no nudge
        if (NUDGE_STRINGS[code]) { want = code; break; }
      }
    }
    if (!want || want === current || !NUDGE_STRINGS[want]) return;

    var target = null;
    for (var j = 0; j < langs.length; j++) {
      if (String(langs[j].iso).toLowerCase().split('-')[0] === want) { target = langs[j]; break; }
    }
    if (!target && !debugLang) return; // not published on this market
    if (!debugLang) {
      try { if (localStorage.getItem('clinks-lang-nudge-' + want)) return; } catch (e) {}
    }
    if (document.querySelector('.geo-push')) return; // country modal wins

    // current path with any existing language prefix stripped…
    var path = location.pathname;
    for (var k = 0; k < langs.length; k++) {
      var r = String(langs[k].root || '').replace(/\/+$/, '');
      if (r && (path === r || path.indexOf(r + '/') === 0)) {
        path = path.slice(r.length) || '/';
        break;
      }
    }
    // …rebuilt under the target language root
    var root = String((target && target.root) || '/' + want).replace(/\/+$/, '');
    var params = new URLSearchParams(location.search);
    params.delete('langnudge');
    params.delete('preview_theme_id');
    var qs = params.toString();
    var url = (root + path || '/') + (qs ? '?' + qs : '');

    var s = NUDGE_STRINGS[want];
    var wrap = document.createElement('div');
    wrap.className = 'lang-nudge';
    wrap.setAttribute('role', 'region');
    wrap.setAttribute('aria-label', s.text);
    wrap.innerHTML =
      '<p class="lang-nudge__text">' + s.text + '</p>' +
      '<a class="lang-nudge__go" href="' + url + '">' + s.cta + '</a>' +
      '<button type="button" class="lang-nudge__close" aria-label="' + s.dismiss + '">&times;</button>';

    var css = document.createElement('style');
    css.textContent =
      '.lang-nudge { position: fixed; inset-block-end: 16px; inset-inline-start: 16px; z-index: 190; display: flex; align-items: center; gap: 14px; max-width: min(430px, calc(100vw - 32px)); background: #fff; border: 1px solid rgb(0 0 0 / .08); border-radius: 10px; padding: 12px 14px; box-shadow: 0 10px 32px rgb(0 0 0 / .18); }' +
      '.lang-nudge__text { margin: 0; font-size: .8125rem; color: #152346; line-height: 1.45; }' +
      '.lang-nudge__go { flex-shrink: 0; background: #152346; color: #fff; padding: 8px 12px; border-radius: 7px; font-size: .75rem; font-weight: 600; text-decoration: none; white-space: nowrap; }' +
      '.lang-nudge__go:hover { background: #0e2a58; }' +
      '.lang-nudge__close { flex-shrink: 0; border: 0; background: none; font-size: 18px; line-height: 1; color: rgb(0 0 0 / .45); cursor: pointer; padding: 4px; }';
    wrap.appendChild(css);
    document.body.appendChild(wrap);

    wrap.querySelector('.lang-nudge__close').addEventListener('click', function () {
      wrap.remove();
      try { localStorage.setItem('clinks-lang-nudge-' + want, '1'); } catch (e) {}
    });
  }

  function scheduleLanguageNudge() {
    var run = function () { setTimeout(languageNudge, 800); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  }

  // Arriving with ?ck-choice=1 means the visitor explicitly picked this store
  // (delivery estimator push, geo modal, announcement link) — remember that
  // as a permanent "stay" for their detected country and clean the URL.
  var arrivedByChoice = new URLSearchParams(location.search).get('ck-choice') === '1';
  if (arrivedByChoice) {
    var cleaned = new URLSearchParams(location.search);
    cleaned.delete('ck-choice');
    cleaned.delete('country');
    cleaned.delete('shpxid');
    var cleanedQs = cleaned.toString();
    try {
      history.replaceState(null, '', location.pathname + (cleanedQs ? '?' + cleanedQs : '') + location.hash);
    } catch (e) {}
  }

  detect(function (cc) {
    var target = siteFor(cc);
    if (!cc || target === here) return;
    if (onPreview && !debugGeo) return;

    if (arrivedByChoice) {
      try { localStorage.setItem(stayKey(cc), '1'); } catch (e) {}
    }

    var url = 'https://' + target + targetPath(cc);
    swapAnnouncement(cc, url);

    var stayed = '';
    try {
      stayed = localStorage.getItem(stayKey(cc)) || sessionStorage.getItem(stayKey(cc)) || '';
    } catch (e) {}
    if (stayed) return;

    if (AUTO_REDIRECT && !navigator.webdriver && !/bot|crawl|spider|slurp/i.test(navigator.userAgent)) {
      location.replace(url);
      return;
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { showModal(cc, url); });
    } else {
      showModal(cc, url);
    }
  });
})();
